/* One circular entry mark follows each catalogue door's construction centre. */
(() => {
  const main = document.querySelector('#MainContent');
  if (!main) return;
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const observed = new WeakSet();
  let pending = 0, scrollFrame = 0, resume = 0;
  const sizes = new ResizeObserver(queue);
  const changes = new MutationObserver(queue);
  function fit() {
    pending = 0;
    const writes = [];
    main.querySelectorAll('.ak-featured-explore-text,.ak-mobile-fifth-explore-text').forEach(label => {
      if (!label.querySelector('.ak-catalogue-entry-emblem')) return;
      const parent = label.parentElement;
      const construction = parent.querySelector('.ak-featured-explore-construction,.ak-mobile-fifth-explore-construction');
      if (!construction) return;
      if (!observed.has(construction)) { observed.add(construction); sizes.observe(construction); sizes.observe(parent); }
      const section = label.closest('section.ak-featured-carousel');
      if (section && !observed.has(section)) {
        observed.add(section);
        changes.observe(section,{attributes:true,attributeFilter:['class','style']});
      }
      const area = construction.getBoundingClientRect(), origin = parent.getBoundingClientRect();
      if (!area.width || !area.height) return;
      const vertical = construction.querySelector('.ak-featured-explore-cross-line-top,.ak-mobile-fifth-explore-cross-line-top')?.getBoundingClientRect();
      const values = {
        '--ak-catalogue-entry-x':`${(vertical?.width ? vertical.left + vertical.width / 2 : area.left + area.width / 2) - origin.left}px`,
        '--ak-catalogue-entry-y':`${area.top + area.height / 2 - origin.top}px`,
        '--ak-catalogue-entry-diameter':`${Math.min(construction.clientWidth,construction.clientHeight) * .55 * 1.4}px`
      };
      writes.push([label,values]);
    });
    writes.forEach(([label,values]) => {
      Object.entries(values).forEach(([key,value]) => {
        if (label.style.getPropertyValue(key) !== value) label.style.setProperty(key,value);
      });
    });
  }
  function queue() {
    // Keep the stationary circle outside a separately composited HTML rotor.
    main.querySelectorAll('section.ak-featured-carousel .ak-catalogue-entry-emblem > svg').forEach(icon => {
      const rotor = document.createElement('div');
      rotor.className = 'ak-catalogue-entry-rotor';
      icon.before(rotor); rotor.append(icon);
    });
    if (!pending) pending = requestAnimationFrame(fit);
  }
  function scroll() {
    main.classList.add('ak-catalogue-entry-scrolling');
    clearTimeout(resume);
    resume = setTimeout(() => main.classList.remove('ak-catalogue-entry-scrolling'),160);
    if (!scrollFrame) scrollFrame = requestAnimationFrame(() => {
      scrollFrame = 0;
      const offset = Math.max(window.scrollY,document.scrollingElement?.scrollTop || 0,main.scrollTop,document.body.scrollTop);
      // Do not invalidate inherited custom properties on the entire page.
      // Only the handful of on-screen catalogue glyphs need this angle.
      const visible = [...main.querySelectorAll('section.ak-featured-carousel .ak-catalogue-entry-rotor')]
        .filter(icon => {
          const rect = icon.getBoundingClientRect();
          return rect.width && rect.height && rect.top < innerHeight && rect.bottom > 0 && rect.left < innerWidth && rect.right > 0;
        });
      const angle = `${reduced.matches ? 0 : offset * .18}deg`;
      visible.forEach(icon => icon.style.setProperty('--ak-catalogue-entry-angle',angle));
    });
  }
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
      (node.matches('.ak-catalogue-entry-emblem,section.ak-featured-carousel') || node.querySelector('.ak-catalogue-entry-emblem'))))) queue();
  }).observe(main,{childList:true,subtree:true});
  document.addEventListener('scroll',scroll,{capture:true,passive:true});
  window.addEventListener('scroll',scroll,{passive:true});
  window.addEventListener('resize',queue,{passive:true});
  ['load','pageshow','ak-bottom-nav-grid-synced','ak-nav-grid-synced'].forEach(name=>window.addEventListener(name,queue));
  document.addEventListener('shopify:section:load',queue);
  if (document.fonts) document.fonts.ready.then(queue);
  queue();
})();
